(function() {
	'use strict';
	angular.module('app.leanProjects')
		.controller('globalSearchProjects', globalSearchProjects);

	function globalSearchProjects($scope, $http, $timeout, $window) {
		var vm = this;

		vm.projectSelected = projectSelected;
		vm.clearText = clearText;
		vm.clearIconToggle = clearIconToggle;
		vm.lastSearch = '';

		function projectSelected($search) {
			if (vm.lastSearch !== $search.searchTerm) {
				vm.lastSearch = $search.searchTerm;
				$window.location.href = '/application/f/home.html#/lean-projects/project-search?drilldown=1&search=' + $search.searchTerm;
			}

		}

		function clearText() {
			vm.projectSearch = '';
			vm.clearer = false;
			$timeout(function() {
				jQuery('.leftNavSearch input').focus();
			});
			projectSelected({
				searchTerm: ''
			});
		}

		function clearIconToggle(term) {
			if (term && term.length) {
				vm.clearer = true;
			} else {
				vm.clearer = false;
			}
		};
	}
})();
